import React, { useState } from "react";
import { Modal, Button } from "reactstrap";
import BaseInput from "../../../toolkit/baseInput";

const ConfirmacionVetadoModal = ({
  show,
  onHide,
  onConfirm,
  isVetado,
  nombrePersona,
  onVerDetalle
}) => {
  const [inputText, setInputText] = useState("");
  const [motivo, setMotivo] = useState("");
  const textoEsperado = isVetado
    ? "AGREGAR A BLACK LIST"
    : "QUITAR DE BLACK LIST";
  const isTextCorrect = inputText === textoEsperado;
  const isMotivoValid =
    motivo.trim().length >= 20 && motivo.trim().length <= 250;

  const handleConfirm = () => {
    if (isTextCorrect && isMotivoValid) {
      onConfirm(motivo);
      setInputText("");
      setMotivo("");
      onHide();
    }
  };

  const handleClose = () => {
    setInputText("");
    setMotivo("");
    onHide();
  };

  return (
    <Modal isOpen={show} toggle={handleClose} centered>
      <div className="modal-header">
        <h5 className="modal-title">Confirmar</h5>
        <button type="button" className="close" onClick={handleClose}>
          <span>&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <p>
          ¿Estás seguro de que deseas{" "}
          {isVetado ? "agregar a Black List" : "quitar de Black List"} a{" "}
          <strong>{nombrePersona}</strong>?
        </p>
        <div className="mb-3">
          <label className="form-label">
            <strong>
              Motivo{" "}
              {isVetado
                ? "para agregar a Black List"
                : "para quitar de Black List"}
              :
            </strong>
          </label>
          <BaseInput
            type="textarea"
            placeholder={`Ingresa el motivo para ${
              isVetado ? "agregar a Black List" : "quitar de Black List"
            } a esta persona...`}
            value={motivo}
            onChange={e => setMotivo(e.target.value)}
            rows={3}
            minLength={20}
            maxLength={250}
            invalid={motivo.length > 0 && motivo.trim().length < 20}
          />
          {motivo.length > 0 && motivo.trim().length < 20 && (
            <div className="text-danger mt-1">
              El motivo debe tener al menos 20 caracteres (actual:{" "}
              {motivo.trim().length})
            </div>
          )}
          {motivo.length > 0 && motivo.trim().length > 250 && (
            <div className="text-danger mt-1">
              El motivo debe tener menos de 250 caracteres (actual:{" "}
              {motivo.trim().length})
            </div>
          )}
        </div>
        <p>
          Para confirmar, escribe{" "}
          <u>
            <span className="font-weight-bold">exactamente</span>
          </u>
          : <strong>"{textoEsperado}"</strong>
        </p>
        <BaseInput
          placeholder={`Escribe "${textoEsperado}"`}
          value={inputText}
          onChange={e => setInputText(e.target.value)}
          invalid={inputText && !isTextCorrect}
        />
        {inputText && !isTextCorrect && (
          <div className="text-danger mt-1">
            El texto debe coincidir exactamente
          </div>
        )}
        <div className="mt-2">
          <Button
            color="info"
            size="sm"
            onClick={() => {
              onVerDetalle();
              handleClose();
            }}
          >
            Ver membresía
          </Button>
        </div>
      </div>
      <div className="modal-footer">
        <Button color="secondary" onClick={handleClose}>
          Cancelar
        </Button>
        <Button
          color={isVetado ? "danger" : "success"}
          onClick={handleConfirm}
          disabled={!isTextCorrect || !isMotivoValid}
        >
          {isVetado ? "Agregar a Black List" : "Quitar de Black List"}
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmacionVetadoModal;
